module.exports = __webpack_public_path__ + "img/noLive.b971e8f4.png";